export const TUTORIAL_ANCHORS = {
  airesTab: 'aires-tab',
  loansTab: 'loans-tab',
  sharesTab: 'shares-tab',
  pfcTab: 'pfc-tab',
  airesTable: 'aires-table',
  tableLoaded: 'table-loaded',
  dataQualityCell: 'data-quality-cell',
  uploadDataBtn: 'upload-data-btn',
  loansUnmappedCounter: 'loans-unmapped-counter',
  sharesUnmappedCounter: 'shares-unmapped-counter',
  pfcUnmappedCounter: 'pfc-unmapped-counter',
  mappingEditBtn: 'mapping-edit-btn',
  mappingSelectAllCheckbox: 'mapping-select-all-checkbox',
  bulkUnmapBtn: 'bulk-unmap-btn',
  bulkAssignBtn: 'bulk-assign-btn',
  pfcRowEditBtn: 'pfc-row-edit-btn',
  moreActionsBtn: 'more-actions-btn',
  actionAddNewProduct: 'action-add-new-product',
  actionDownloadTemplate: 'action-download-template',
  actionUploadMapFile: 'action-upload-map-file',
  actionOpenMappingSpec: 'action-open-mapping-spec',
} as const;

export type TutorialAnchorKey = keyof typeof TUTORIAL_ANCHORS;

export const dataTourSelector = (anchor: (typeof TUTORIAL_ANCHORS)[TutorialAnchorKey]) => `[data-tour="${anchor}"]`;
